import { render, staticRenderFns } from "./AddScopeOfPracticeGroupModal.vue?vue&type=template&id=0bc692fb&scoped=true&"
import script from "./AddScopeOfPracticeGroupModal.vue?vue&type=script&lang=js&"
export * from "./AddScopeOfPracticeGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc692fb",
  null
  
)

export default component.exports